<template>
    <div>
        <div class="searcher-container-negative mb-5 mt-5">
            <!--<v-text-field @input="searchData($event)" label="Busca la empresa" class="searcher form-control form-search"
                single-line hide-details></v-text-field>-->
            <label for="showFilters"><input id="showFilters" class="form-check-input" type="checkbox" v-model="showFilters"> Mostrar Filtros</label>
        </div>
        <v-data-table :headers="headers" :items="listInsignias" :search="search" class="elevation-1 table align-middle table-licences text-center small"
            loading
            loading-text="Aún no tienes insignias"
            mobile-breakpoint="0"
            :items-per-page="10"
            :footer-props="{
                prevIcon: 'fa-solid fa-chevron-left',
                nextIcon: 'fa-solid fa-chevron-right',
                'items-per-page-text':'Mostrando: ',
                'items-per-page-options': [5, 10, 20, 30, 40, 50]
            }">
            <template v-slot:body.prepend>
                <tr v-show="showFilters">
                    <td colspan="1"></td>
                    <td><input type="text" class="form-control" placeholder="Nombre" @input="searchData($event)" v-model="busqueda.name" ></td>
                    <td><input type="text" class="form-control" placeholder="Empresa" @input="searchData($event)" v-model="busqueda.client" ></td>
                    <td><input type="text" class="form-control" placeholder="Ruta" @input="searchData($event)" v-model="busqueda.ruta" ></td>
                    <td colspan="2"></td>
                </tr>
            </template>
            <template v-slot:item="row">
                <tr>
                    <td>{{ row.item.id }}</td>
                    <td>{{ row.item.FullName }}</td>
                    <td>{{ row.item.clientName }}</td>
                    <td>{{ row.item.routeName }}</td>
                    <td>{{ row.item.fechaCreacion }}</td>
                    <td><a v-bind:href="row.item.url_insignia" class="btn btn-info" target="_blank"><i class="fas fa-download"></i></a>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: ["insignias", "headertabs", "rol"],
    data() {
        return {
            search: '',
            headers: this.headertabs,
            listInsignias: [],
            showFilters: false,
            busqueda: { name : "", client : "", ruta : "" }
        };
    },
    mounted() {      
        this.getData();  
    },
    methods: {
        getData(){
            axios.get(`${this.insignias}?withUsers=true`).then((data) => {
                if(data.data == null) return;
                this.listInsignias = data.data;
            });
        },
        searchData(event){
            let search = ``;//`&search=${event}`;
            let searchByTipo = this.busqueda.ruta != "" ? `&ruta=${this.busqueda.ruta}` : ``;
            let searchByName = this.busqueda.name != "" ? `&name=${this.busqueda.name}` : ``;
            let searchByEmpresa = this.busqueda.client != "" ? `&empresa=${this.busqueda.client}` : ``;
            let filters = searchByName+searchByTipo+searchByEmpresa;
            axios.get(`${this.insignias}?withUsers=true${event}${filters}`).then((data) => {
                if(data.data == null) return;
                this.listInsignias = data.data;
            });
        }
    }
};
</script>
